import {combineReducers} from 'redux'
import paginationOffset from './paginationOffset'
import Storeclicked from './Storeclicked'
import MapCenterPoint, { InfoBoxCenter } from './MapCenterPoint'
import StoreLocations from './StoreLocations'
import CategoryChoosed from './CategoryChoosed'
import MapDirectionData, { InfoBox, MapZoomValue, MadRadius } from './MapDirectionData'
import SiteData from './SiteData'
var reducers = combineReducers({
    paginationOffset : paginationOffset,
    Storeclicked : Storeclicked,
    MapCenterPoint: MapCenterPoint,
    StoreLocations: StoreLocations,
    CategoryChoosed: CategoryChoosed,
    MapDirectionData: MapDirectionData,
    SiteData: SiteData,
    InfoBox: InfoBox,
    MapZoomValue: MapZoomValue,
    InfoBoxCenter: InfoBoxCenter,
    MadRadius: MadRadius,
});
export default reducers;